<div class="list-group gap-2 p-3">
  <a *ngFor="let item of getMenuItems"
    class="profile-settings-menu-item"
    [class.active]="isRouteActive(item)"
    (click)="navigateToPage(item)"
  >
    {{ item }}
  </a>
</div>
